<!-- 服务需求确认单，截图使用 -->
<template>
  <el-dialog
    title="服务需求确认单"
    :visible.sync="dialogIsShow"
    :width="dia_width"
    @close="closeDia"
    append-to-body
  >
    <!-- <el-table
      :data="jobData"
      :span-method="objectSpanMethod"
      :border="true"
      v-loading="listLoading"
      stripe
      style="width: 100%"
    >
      <el-table-column prop="Title" :label="tableTitle" width="100">
        <el-table-column prop="Title" label="标题"> </el-table-column>
        <el-table-column prop="Value" label="值"> </el-table-column>
      </el-table-column>
 
    </el-table> -->
<div class="table-con">
  <div class="canvasImg" ref="canvasImg" >
      <!-- 发单方服务需求确认单 -->
      <table border="0" v-if="isSender" >
        <tr>
          <th colspan="2" style="text-align: center;">{{ tableTitle }}</th>
        </tr>
        <tr>
          <th>服务地址</th>
          <td>{{ jobBaseInfo.JobAddress }}</td>
        </tr>
        <tr>
          <th>进场时间</th>
          <!-- <td>{{ jobBaseInfo.ExecStartDate }}</td> -->
          <td style="padding-top: 0px;padding-bottom: 0px; ">
            <input type="input" class="inputStyle" maxlength="30"  style="line-height: 25px;" v-model="jobDetailInfo.ExecStartDate_JobExtend" slot="reference" @blur="submitData('ExecStartDate')" />
          </td>
        </tr>
        <tr>
          <th>预计服务时长</th>
          <td>{{ jobBaseInfo.ServiceDayCount }}天</td>
        </tr>
        <tr>
          <th>服务人数</th>
          <td>{{ jobDetailInfo.EngineerCount }}</td>
        </tr>
        <tr>
          <th>服务产品</th>
          <!-- <td>{{ jobDetailInfo.ProductCategoryName }}</td> -->
          <td style="padding-top: 0px;padding-bottom: 0px; ">
            <input type="input" class="inputStyle" maxlength="150" style="line-height: 25px;" v-model="jobDetailInfo.ProductCategoryName" slot="reference" @blur="submitData('ProductName')" />
          </td>
        </tr>
        <tr>
          <th>产品数量</th>
          <!-- <td>{{ jobDetailInfo.ProductDeviceCount }}</td> -->
          <td style="padding-top: 0px;padding-bottom: 0px;">
            <input type="input" class="inputStyle" maxlength="150" style="line-height: 25px;" v-model="jobDetailInfo.ProductDeviceCount" @blur="submitData('DeviceCount')"  />
          </td>
        </tr>
        <tr>
          <th>服务内容</th>
          <td><div v-html="jobDetailInfo.Content"> </div></td>
        </tr>
        <tr v-if="isAboutHigh">
          <th>是否涉及登高</th>
          <td>{{ isAboutHigh }}</td>
        </tr>
        <tr>
          <th>证件要求</th>
          <td>{{ jobDetailInfo.CertRemark }}</td>
        </tr>
        <tr>
          <th>工具要求</th>
          <td>{{ jobDetailInfo.ToolRemark }}</td>
        </tr>
        <tr>
          <th>接单方上门名义</th>
          <td>{{ jobBaseInfo.EngineerToDoorName }}</td>
        </tr>
        <tr>
          <th>现场联系方式</th>
          <td>现场联系人：{{ jobBaseInfo.JobLinkMan }}       现场联系方式：{{ jobBaseInfo.JobHandSet }}</td>
        </tr>
        <tr>
          <th>技术专家评估意见</th>
          <td>1.执行建议：{{ jobDetailInfo.ExecuteSuggest }}；2.特殊事项：{{jobDetailInfo.SpecialNotes}}；3.风险提醒：{{jobDetailInfo.RiskWarning}}</td>
        </tr>
        <tr>
          <td colspan="2">特殊说明：<br><div id="specialContent1" v-html="jobDetailInfo.SpecialContent"></div></td>
        </tr>
        <!-- <tr>
          <td colspan="2">
            <img :src="imgUrl" />
          </td>
        </tr> -->
      </table>

      <!-- 接单方服务需求确认单 -->
      <table border="0" v-else >
        <tr>
          <th colspan="2" style="text-align: center;">{{ tableTitle }}</th>
        </tr>
        <tr>
          <th>服务地址</th>
          <td>{{ jobBaseInfo.JobAddress }}</td>
        </tr>
        <tr>
          <th>进场时间</th>
          <!-- <td>{{ jobBaseInfo.ExecStartDate }}</td> -->
          <td style="padding-top: 0px;padding-bottom: 0px; ">
            <input type="input" class="inputStyle" maxlength="30" v-model="jobDetailInfo.ExecStartDate2_JobExtend" slot="reference" @blur="submitData('ExecStartDate2')" />
          </td>
        </tr>
        <tr>
          <th>预计服务时长</th>
          <td>{{ jobBaseInfo.ServiceDayCount }}天</td>
        </tr>
        <tr>
          <th>服务人数</th>
          <td>{{ jobDetailInfo.EngineerCount  }}</td>
        </tr>
        <tr>
          <th>服务产品</th>
          <!-- <td>{{ jobDetailData.ProductCategoryName }}</td> -->
          <td style="padding-top: 0px;padding-bottom: 0px; ">
            <input type="input" class="inputStyle" maxlength="150" style="line-height: 25px;" v-model="jobDetailInfo.ProductCategoryName2" @blur="submitData('ProductName2')" />
          </td>
        </tr>
        <tr>
          <th>产品数量</th>
          <!-- <td>{{  jobDetailData.ProductDeviceCount }}</td> -->
          <td style="padding-top: 0px;padding-bottom: 0px; ">
            <input type="input" class="inputStyle" maxlength="150" style="line-height: 25px;" v-model="jobDetailInfo.ProductDeviceCount2" @blur="submitData('DeviceCount2')"  />
          </td>
        </tr>
        <tr>
          <th>服务内容</th>
          <td><div v-html="jobDetailInfo.Content"> </div></td>
        </tr>
        <tr v-if="isAboutHigh">
          <th>是否涉及登高</th>
          <td>{{ isAboutHigh }}</td>
        </tr>
        <tr>
          <th>证件要求</th>
          <td>{{ jobDetailInfo.CertRemark }}</td>
        </tr>
        <tr>
          <th>工具要求</th>
          <td>{{ jobDetailInfo.ToolRemark }}</td>
        </tr>
        <tr>
          <th>接单方上门名义</th>
          <td>{{ jobBaseInfo.EngineerToDoorName }}</td>
        </tr> 
        <tr>
          <th>技术专家评估意见</th>
          <td>1.执行建议：{{ jobDetailInfo.ExecuteSuggest }}；2.特殊事项：{{jobDetailInfo.SpecialNotes}}；3.风险提醒：{{jobDetailInfo.RiskWarning}}</td>
        </tr>
        <tr>
          <td colspan="2"> 特殊说明：<br> <div id="specialContent2" v-html="jobDetailInfo.SpecialContent2"></div>
          </td>
        </tr>
      </table>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="copyFont">复制文字</el-button>
      <el-button size="small" @click="copyImg">复制图片</el-button>
    </div>
</div>
  </el-dialog>
</template>

<script>
import html2canvas from 'html2canvas';
import {
  updateJobExtendInfo,  //工单详情
} from "@/service/job";
import couponsIssueVue from '../../coupons/couponsIssue.vue';
export default {
  
  data() {
    return {
      dialogIsShow: false,
      isSender: true,
   
      jobBaseInfo: {},       //工单信息
      jobDetailInfo:{},//工单详细信息

      tableTitle: "",
      imgUrl:'',
      dia_width:'430px'
    };
  },
  computed:{
    // twoProductCategory(){
    //     var pro="";
    //     if(this.jobDetailInfo&&this.jobDetailInfo.JobProductLineList){
    //         this.jobDetailInfo.JobProductLineList.forEach(element => {
    //             pro+=(pro==""?element.ThreeProductCategoryName:","+element.ThreeProductCategoryName);
    //         });
    //     }
    //     return pro;
    // },
    // productCategoryCount(){
    //     var proCount="";
    //     if(this.jobDetailInfo&&this.jobDetailInfo.JobProductLineList){
    //         if( this.jobDetailInfo.JobProductLineList.length==1)
    //         {
    //             return  this.jobDetailInfo.JobProductLineList[0].DeviceCount;
    //         }
    //         else { 
    //         this.jobDetailInfo.JobProductLineList.forEach(element => {
    //             proCount+=(proCount==""?element.ThreeProductCategoryName+':'+element.DeviceCount:","+element.ThreeProductCategoryName+':'+element.DeviceCount);
    //         });
    //       }
    //     }
    //     return proCount;
    // },
    isAboutHigh(){ //是否涉及登高
        var pro="";
        if(this.jobDetailInfo&&this.jobDetailInfo.ServiceProblemList){
            this.jobDetailInfo.ServiceProblemList.forEach(element => {
               if(element.Title.indexOf('登高')>=0){
                     if(element.ProblemOptionList){
                        element.ProblemOptionList.forEach(ele=>{
                            if(ele.IsChecked)
                            {
                                pro=ele.Content;
                                return pro;
                            }
                        });
                     }
               }
            });
        }
        return pro;
    },
     
  },
  methods: {
    closeDia(){
      this.jobBaseInfo ={};
      this.jobDetailInfo ={};
    },
    openDia(jobBaseData,jobDetailData, isSender) {
      this.dialogIsShow = true;
      this.isSender = isSender;
      this.dia_width=isSender?'430px':'380px';
      if (jobBaseData) this.jobBaseInfo = jobBaseData;
      if (jobDetailData) 
      { 
          // console.log("requireConfirm:"+ jobDetailData.SpecialContent )
        // console.log("jobDetailData:"+JSON.stringify(jobDetailData))
        this.jobDetailInfo = jobDetailData;
         
        // this.jobDetailInfo.SpecialContent=
        // '特殊说明：<br/>'+JSON.stringify(this.jobDetailInfo.SpecialContent)
        //     .replace(/\\n/g,'<br/>')
        //     .replace('"','').replace('"','');
            
        //     this.jobDetailInfo.SpecialContent2=
        //     '特殊说明：<br/>'+JSON.stringify(this.jobDetailInfo.SpecialContent2)
        //     .replace(/\\n/g,'<br/>')
        //     .replace('"','').replace('"','');
      }

 
      this.tableTitle = `服务需求确认单(${
        this.isSender ? "发单方" : "接单方"
      })`;
      //   this.getJobData();
    },
    //设置合并列
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      //   if (rowIndex === 0) {
      //     //第一列
      //     if (rowIndex === 0) {
      //       return {
      //         rowspan: 1,
      //         colspan: 2,
      //       };
      //     } else {
      //       return {
      //         rowspan: 0,
      //         colspan: 0,
      //       };
      //     }
      //   }
    },
    //获取工单统计数据
    async getJobData() {
      this.listLoading = true;

      setTimeout(() => {
        // if (res.Result != 1) {
        //   return this.$message.error("获取失败请联系开发人员");
        // }
        let data = [
          {
            Title: "服务地址",
            Value: "上海",
          },
          {
            Title: "进场时间",
            Value: "2024-08-01",
          },
        ];
        this.jobData = data;
        this.listLoading = false;
      }, 600);
    },

    //提交数据
    submitData(fileName){
      var productCategoryName=this.jobDetailInfo.ProductCategoryName;
      var productCategoryName2=this.jobDetailInfo.ProductCategoryName2;
      var productDeviceCount=this.jobDetailInfo.ProductDeviceCount;
      var productDeviceCount2=this.jobDetailInfo.ProductDeviceCount2;
      var execStartDate=this.jobDetailInfo.ExecStartDate_JobExtend;
      var execStartDate2=this.jobDetailInfo.ExecStartDate2_JobExtend;
      console.log("productCategoryName2:"+productCategoryName2+";productDeviceCount2:"+productDeviceCount2+";execStartDate2:"+execStartDate2)
    
      var data={
        JobId:this.jobBaseInfo.Id,
        FieldName:fileName
      };
      console.log("productCategoryName:"+productCategoryName);
      if(fileName=="ProductName")
      { 
        data.FieldValue= productCategoryName ;
      }
      if( fileName=="ProductName2")
      { 
        data.FieldValue= productCategoryName2;
      }
      else if(fileName=="DeviceCount" )
      { 
        data.FieldValue= productDeviceCount ; 
      }
      else if( fileName=="DeviceCount2")
      { 
        data.FieldValue= productDeviceCount2; 
      }
      else if(fileName=="ExecStartDate" )
      { 
        data.FieldValue= execStartDate ; 
      }
      else if( fileName=="ExecStartDate2")
      { 
        data.FieldValue= execStartDate2; 
      }
    console.log("data:"+JSON.stringify(data));
      updateJobExtendInfo(data).then(res=> {
          if(res.Result != 1) {
              return this.$message.error(res.Message)
          }
          return this.$message.success(res.Message) 
          
      });

    },
    //复制文字
   async copyFont(){
        var con='';
        if(this.isSender){
           con+='服务需求确认单(发单方)\r';
          con+=`服务地址：${this.jobBaseInfo.JobAddress}\r`;
          con+=`进场时间：${this.jobDetailInfo.ExecStartDate_JobExtend}\r`;
          con+=`预计服务时长：${this.jobBaseInfo.ServiceDayCount}天\r`;
          con+=`服务人数：${this.jobDetailInfo.EngineerCount}\r`;
          con+=`服务产品：${this.jobDetailInfo.ProductCategoryName}\r`;
          con+=`产品数量：${this.jobDetailInfo.ProductDeviceCount}\r`;
          con+=`服务内容：${this.jobDetailInfo.Content}\r`;
          if(this.isAboutHigh){
            con+=`是否涉及登高：${this.isAboutHigh}\r`;
          }
          con+=`证件要求：${this.jobDetailInfo.CertRemark}\r`;
          con+=`工具要求：${this.jobDetailInfo.ToolRemark}\r`;
          con+=`接单方上门名义：${this.jobBaseInfo.EngineerToDoorName} \r`; 
           con+=`现场联系方式：现场联系人：${this.jobBaseInfo.JobLinkMan} 现场联系方式：${this.jobBaseInfo.JobHandSet}\r`;
          con+=`技术专家评估意见：1.执行建议：${this.jobDetailInfo.ExecuteSuggest}；2.特殊事项：${this.jobDetailInfo.SpecialNotes}；3.风险提醒：${this.jobDetailInfo.RiskWarning}\r`;
          // con+=`特殊说明：\r${this.jobDetailInfo.SpecialContent.replace('<br/>','/\r')}`;
          con+=`特殊说明：\r${document.getElementById('specialContent1').innerText}`;
 
        }
        else{
           con+='服务需求确认单(接单方)\r';
          con+=`服务地址：${this.jobBaseInfo.JobAddress}\r`;
          con+=`进场时间：${this.jobDetailInfo.ExecStartDate2_JobExtend}\r`;
          con+=`预计服务时长：${this.jobBaseInfo.ServiceDayCount}天\r`;
          con+=`服务人数：${this.jobDetailInfo.EngineerCount}\r`;
          con+=`服务产品：${this.jobDetailInfo.ProductCategoryName2}\r`;
          con+=`产品数量：${this.jobDetailInfo.ProductDeviceCount2}\r`;
          con+=`服务内容：${this.jobDetailInfo.Content}\r`;
          if(this.isAboutHigh){
            con+=`是否涉及登高：${this.isAboutHigh}\r`;
          }
          con+=`证件要求：${this.jobDetailInfo.CertRemark}\r`;
          con+=`工具要求：${this.jobDetailInfo.ToolRemark}\r`;
          con+=`接单方上门名义：${this.jobBaseInfo.EngineerToDoorName}\r`;
          con+=`现场联系方式：${this.jobDetailInfo.EngineerCount}\r`;
          con+=`技术专家评估意见：1.执行建议：${this.jobDetailInfo.ExecuteSuggest}；2.特殊事项：${this.jobDetailInfo.SpecialNotes}；3.风险提醒：${this.jobDetailInfo.RiskWarning}\r`;
          // con+=`特殊说明：\r${this.jobDetailInfo.SpecialContent.replace('<br/>','/\r')}`;
          con+=`特殊说明：\r${document.getElementById('specialContent2').innerText}`;
        }
  
      try {  
      var re=  await navigator.clipboard.writeText(con);
      console.log('re:'+JSON.stringify(re));
        return this.$message.success('已复制') 
      } catch (err) {
          console.error('复制失败,将使用fallbackCopy', err);
         fallbackCopy(con);
        // return this.$message.success('复制失败');
      }
    },
    //
    fallbackCopy(con){
          const el = document.createElement('textarea');
          el.value = con;
          el.setAttribute('readonly', '');
          el.style.position = 'absolute';
          el.style.left = '-9999px';
          document.body.appendChild(el);
          el.select();
          document.execCommand('copy');
          document.body.removeChild(el);
          return this.$message.success('已成功复制') 
    },
    //复制图片
   async copyImg(){ 
      try {
        const canvas = await html2canvas(this.$refs.canvasImg) // 在这里，将需要转换成图片的部分作为参数传入html2canvas
        const image = canvas.toDataURL() // 将生成的canvas转换为DataURL格式
        this.imgUrl = image;
        console.log(image) // 可以将image自行存储

        const data = await fetch(this.imgUrl);
        const blob = await data.blob();

        await navigator.clipboard.write([ 
          new ClipboardItem({
            [blob.type]: blob,
          }),
        ]);

        return this.$message.success('已复制') 

      } catch (e) {
        throw new Error(e)
      }
 
    },
  },
};
</script>

<style lang="scss" scoped>
.table-con{
  .canvasImg{
  // border: 1px solid red;
  padding:5px;
  }
    table{
        border-collapse: collapse;
        width:100% ;
    }
    table th{
        width: 115px;
        border: 0.5px solid black;
        text-align: right;
        padding: 5px; 
        vertical-align: top;
    }
    table td{ 
        border: 0.5px solid black;
        padding: 5px; 
    }
    table td .inputStyle{
      width: 90%;
      padding: 2px ;
      border-width: 0px;
      //height: 50px;  
    }
    table td input{
      color: #606266;
      border: 1px solid red ;
       padding: 2px;
      height: 20px;  
    }
    table td .inputStyle:focus{
      border-color: #409EFF;
      outline: 0;
      box-shadow: 0 0 6px rgba(0, 0, 0, .6);;
      border-color: #c1c1c1; 
      //  margin-left: 3px;
      padding: 2px;
      height: 20px;  
    }
    .dialog-footer{
      padding: 5px;
      text-align: right;
    }
}
</style>